import { Box } from '@mui/material';
import ScreenAllEvents from './_components/ScreenAllEvents';

const DefenseMonitoringLayout = () => {
  return (
    <>
      <Box
        style={{
          display: 'flex',
          flexDirection: 'row',
          width: '100%',
        }}
        sx={{
          '@media (max-width: 900px)': {
            width: '100%',
          },
        }}
      >
        <ScreenAllEvents />
      </Box>
    </>
  );
};

export default DefenseMonitoringLayout;
